import { getCoreRowModel, useReactTable, flexRender } from "@tanstack/react-table";
import TextLimit from "Api/TextLimit";
import React, { Fragment } from "react";
import { Card, CardBody, Table } from "reactstrap";
import { getDateCell } from "../helpers";
import Tippy from "@tippyjs/react";

const Details = ({ data = [] }) => {
 // Log the value to see what it contains

  const columns = [
    {
      id: "school",
      header: "School",
      cell: (prop) => {
        const { school, community } = prop.row.original;

        const schoolName = school?.name || "-";
        const bestuurName = community?.name || "Onbekend bestuur";

        return `${bestuurName} - ${schoolName}`;
      },
    },
    {
      accessorKey: "groups",
      header: "Functie",
      cell: (prop) => {
        const groups = prop.getValue();
        if (!groups) return "-";
        const value = groups.map((g) => g.name).join(" ");
        return (
          <>
            {window.innerWidth > 1250
              ? TextLimit.limitFunctiesLargeScreen(value)
              : TextLimit.limitFunctiesSmallScreen(value)}
          </>
        );
      },
    },
{
  accessorKey: "code",
  header: "Code",
  cell: (prop) => {
    const value = prop.getValue(); 
    const abbr = value?.abbr || ""; 
    const name = value?.name || "";  

    return (
      <Tippy content={name || "No name available"} placement="bottom">
        <a href="#">
          {TextLimit.codeLimitOptionTwo(abbr, name) ?? "----"}  {/* Fallback if function returns null */}
        </a>
      </Tippy>
    );
  },
}
,

    {
      id: "datesFirst",
      header: "Geselecteerde dag",
      cell: (prop) => {
        const { dates } = prop.row.original;
        if (!dates?.firstDate) return "-";
        return getDateCell(dates.firstDate);
      },
    },
    {
      id: "datesLast",
      header: "Laatste dag",
      cell: (prop) => {
        const { dates } = prop.row.original;
        if (!dates?.lastDate) return "-";
        return getDateCell(dates.lastDate);
      },
    },
    {
      accessorKey: "gym",
      header: "Gym",
      cell: (prop) => <>{prop.getValue() || "-"}</>,
    },
    {
      accessorKey: "absent",
      header: "Afwezige",
      cell: (prop) => {
        const { absent } = prop.row.original;
        if (!absent) return "-";
        return (
          <>
            {window.innerWidth > 1250
              ? TextLimit.AfwezigeLimitOptionOne(
                  absent.firstName,
                  absent.middleName,
                  absent.lastName
                )
              : TextLimit.AfwezigeLimitOptionTwo(
                  absent.firstName,
                  absent.middleName,
                  absent.lastName
                )}
          </>
        );
      },
    },
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Fragment>
      
          <Table
            size="sm"
            borderless
            className="mb-0 planscreen__table planscreen__table--details "
          >
            <thead>
              {table.getHeaderGroups().map((headerGroup, i) => (
                <tr key={i}>
                  {headerGroup.headers.map((header, index) => (
                    <th key={index} style={{ width: header.getSize() }}>
                      <div className="px-0">
                        {header.column.columnDef.header}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.map((row, i) => (
                <tr key={i}>
                  {row.getVisibleCells().map((cell, index) => (
                    <td key={index} style={{ width: cell.column.getSize() }}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
      
    </Fragment>
  );
};

export default Details;